/* SUPER OFERTA HALLOWEEN (Nicolás, 19 oct 2026): gomitas NAD+, Ashwagandha, Óxido Nítrico y Vinagre.
   2 frascos del mismo producto a $32.990 (antes $36.990, ahorras $4.000) hasta el sáb 31 oct 23:59. Se apaga solo el 1 nov 00:00
   y la página vuelve a $36.990. OJO: el precio real lo cobra Releasit (oferta 2 frascos): bajarla a $32.990 y volver a $36.990 el 1 nov.
   Precio de referencia tachado: $36.990 (el pack normal), NO $59.980. Los textos dentro de [data-cm-fijo] o de la píldora no se tocan.
   La etiqueta "Recomendado" del pack 2 pasa a "Oferta Halloween" en naranjo. */
(function(){
  var FIN = new Date('2026-11-01T00:00:00-03:00').getTime();
  if(!(Date.now() < FIN)) return;
  if(!/\/products\/(60-gomitas-|gomitas-vinagre)/i.test(location.pathname)) return;
  var SIMPLES = [['$18.495','$16.495'],['$22.990','$4.000'],['$617','$550'],['9 de noviembre','31 de octubre'],['RECOMENDADO','OFERTA HALLOWEEN'],['Recomendado','Oferta Halloween']];
  function cambiar(txt){
    if(txt.indexOf('$59.980') >= 0 || txt.indexOf('$36.990') >= 0){
      txt = txt.split('$36.990').join('\u0001').split('$59.980').join('$36.990').split('\u0001').join('$32.990');
    }
    for(var i=0;i<SIMPLES.length;i++){ if(txt.indexOf(SIMPLES[i][0])>=0){ txt = txt.split(SIMPLES[i][0]).join(SIMPLES[i][1]); } }
    return txt;
  }
  var ultimo = new WeakMap();
  function recorrer(raiz){
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null), n, nv;
    while((n = w.nextNode())){
      if(ultimo.get(n) === n.nodeValue) continue;
      var par = n.parentNode;
      var p = par && par.nodeName;
      if(p === 'SCRIPT' || p === 'NOSCRIPT' || (par && par.closest && par.closest('#cm-hw-pill,[data-cm-fijo]'))){ ultimo.set(n, n.nodeValue); continue; }
      nv = cambiar(n.nodeValue);
      if(nv !== n.nodeValue){
        n.nodeValue = nv;
        if(/oferta halloween/i.test(nv) && p !== 'STYLE' && par.style){ par.style.setProperty('color', '#FF8A2A', 'important'); }
      }
      ultimo.set(n, n.nodeValue);
    }
  }
  function pildora(){
    if(document.getElementById('cm-hw-pill')) return;
    var t = document.querySelector('.product__info-container .product__title');
    if(!t) return;
    var d = document.createElement('div'); d.id = 'cm-hw-pill';
    d.setAttribute('style','display:inline-flex;align-items:center;gap:8px;margin:6px 0 10px;padding:8px 14px;border-radius:999px;background:#FF8A2A;color:#0A0A0A;font:800 13px/1.25 Inter,system-ui,sans-serif');
    d.textContent = '✦ Super oferta Halloween · 2 frascos $32.990 (antes $36.990) · hasta el sábado 31 de octubre';
    t.parentNode.insertBefore(d, t.nextSibling);
  }
  function correr(){ pildora(); recorrer(document.body); }
  function iniciar(){
    correr();
    var cola = null;
    new MutationObserver(function(){ if(cola) return; cola = setTimeout(function(){ cola = null; correr(); }, 120); })
      .observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', iniciar); } else { iniciar(); }
})();
